import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IndividualResponseComponent } from 'components/AddOrEditFormPage/Form/Main/ResponseView/index'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  questionsAndAnswers: {
    backgroundColor: '#fff',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '20px 0 0',
    minHeight: 150,
    maxHeight: 'calc(100vh - 278px)',
    borderBottom: '1px solid gray',
    borderLeft: '1px solid gray',
    borderRight: '1px solid gray',
    borderTop: '1px solid gray',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'calc(100vh - 267px)',
    },
    [theme.breakpoints.down('xs')]: {
      maxHeight: 'calc(100vh - 259px)',
    },
  },
})

class IndividualFormResponse extends Component {
  render() {
    return (
      <IndividualResponseComponent
        sectionsByID={this.props.sectionsByID}
        response={this.props.response}
        inbox
        classes={this.props.classes}
      />
    )
  }
}

export default connect(
  state => ({
    sectionsByID: state.view.dialogs?.individualFormResponse?.sectionsByID,
    response: state.view.dialogs?.individualFormResponse?.response,
  }),
  null,
)(withStyles(styles)(IndividualFormResponse))
